import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import heroImage from "@/assets/hero-chicago-skyline.webp";
const Hero = () => {
  return (
    <section className="relative min-h-[90vh] flex items-end overflow-hidden">
      <div
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: `linear-gradient(135deg, rgba(34, 54, 73, 0.3) 0%, rgba(34, 54, 73, 0.2) 100%), url(${heroImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />

      <div className="container relative z-10 px-4 md:px-6 pb-16 md:pb-8">
        <div className="max-w-3xl animate-fade-in">
          <h1 className="text-3xl lg:text-7xl font-bold text-white mb-4 md:mb-6 leading-tight md:text-5xl font-sans">
            Develop Leaders. Strengthen Teams. <span className="whitespace-nowrap">Transform Organizations.</span>
          </h1>
          <p className="text-base md:text-xl text-white/90 mb-6 md:mb-8 leading-relaxed italic max-w-full">
            Helping individuals and organizations create strategies for next-level results in life and business.
          </p>
          <div className="flex flex-row flex-wrap gap-2 md:gap-4">
            <Button
              size="default"
              variant="hero"
              className="text-xs md:text-sm px-3 md:px-4"
              onClick={() =>
                window.open("https://link.glowuplead.com/widget/service-menus/glowupleadprograms", "_blank")
              }
            >
              Start Your Transformation
              <ArrowRight className="ml-1 h-3 w-3 md:ml-2 md:h-4 md:w-4" />
            </Button>
            <Button
              size="default"
              variant="hero"
              className="text-xs md:text-sm px-3 md:px-4"
              onClick={() => {
                const programsSection = document.getElementById("programs");
                programsSection?.scrollIntoView({ behavior: "smooth" });
              }}
            >
              Explore Programs
              <ArrowRight className="ml-1 h-3 w-3 md:ml-2 md:h-4 md:w-4" />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
export default Hero;
